<template>
  <div class="login">
    <div class="background">
      <BackgroundImage />
      <div class="hero-text">
        <transition name="slogan-fade" mode="out-in">
          <div :key="slogansIndex">
            <div class="title">{{ slogan.title }}</div>
            <div
              class="description"
              :class="'description-delay-' + slogansIndex"
            >
              {{ slogan.description }}
            </div>
          </div>
        </transition>
      </div>
      <!--<MovingBoxAnimation class="moving-box-animation" />-->
    </div>
    <div class="side-bar">
      <div class="content-outer">
        <div class="logo-section">
          <div class="logo" v-if="app.whiteLable != -1">
            <img
              class="eyecon-logo"
              v-if="app.whiteLabel == 0"
              src="@/assets/eyecon-invert.svg"
            />
            <div class="drop-shadow" v-if="app.whiteLabel == 0"></div>
            <img
              class="white-label-logo"
              v-if="app.whiteLabel != 0"
              :src="logoPath"
            />
          </div>

          <div class="title-section">
            <div class="eyecon">{{ app.productName }}</div>
            <div class="app-name">{{ app.appTitle }}</div>
          </div>
        </div>
        <div class="content">
          <div
            class="account-input"
            v-if="!accountExist && !googleSignInSuccess && domainName"
          >
            <div class="topic"><span>Sign In</span></div>

            <div class="label">Workspace</div>
            <div class="workspace-input" v-if="!hasDomainParam">
              <input
                ref="subDomain"
                v-model="subDomain"
                type="text"
                :disabled="isBusy"
              />
              <div class="domain-name">.{{ domainName }}</div>
            </div>
            <div class="workspace" v-else>
              <div>{{ subDomain }}.{{ domainName }}</div>
            </div>

            <div class="label">User Id or E-mail Address</div>
            <input
              ref="account"
              type="text"
              v-model="account"
              @keyup.enter="checkAccountExist"
              :disabled="isBusy"
            />
            <button
              @click="checkAccountExist"
              :disabled="!allowSignIn || isBusy"
            >
              <Spinner
                v-if="isBusy && allowSignIn"
                :width="'3px'"
                :size="'24px'"
                :color="'#fff'"
              />
              <span>Continue</span>
            </button>
            <div class="google-sign-in-outer">
              <div v-if="allowGoogleSignIn">or</div>
              <div
                :class="{
                  'disable-google-sign-in':
                    !allowGoogleSignIn || account.length > 0 || isBusy,
                }"
                class="google-sign-in-button"
                ref="googleSignInButton"
              ></div>
            </div>
            <div class="error-message">
              <div class="message-body" v-if="errorMessage">
                <IconError />
                {{ errorMessage }}
              </div>
            </div>
          </div>
          <div v-else-if="googleSignInSuccess && !inputVerificationCode">
            <GoogleSignInCompleted
              :message="loginSuccessMessage"
              :userInfo="googleUserInfo"
              :subDomain="subDomain"
              :tenantId="tenantId"
              :loginKey="loginKey"
              :hostname="domainName"
              v-if="googleUserMapped"
            />
            <GoogleSignInMapping
              :googleIdToken="googleIdToken"
              :userInfo="googleUserInfo"
              :subDomain="subDomain"
              :tenantId="tenantId"
              :loginKey="loginKey"
              :hostname="domainName"
              @back="reset"
              @account-linked="accountLinked"
              v-else
            />
          </div>
          <div
            class="account-input"
            v-else-if="
              accountExist &&
              sendForgotPasswordStatus == -1 &&
              !inputVerificationCode
            "
          >
            <div class="password-topic">
              <div class="back-button" @click="backButtonClick" title="Back">
                <IconArrowLeft />
              </div>
              <div>Welcome, {{ userName }}!</div>
            </div>

            <div class="label">Enter the password to continue signing in:</div>
            <input
              ref="password"
              type="password"
              v-model="password"
              @keyup.enter="userLogin"
            />

            <div class="countdown-line">
              <div
                class="countdown-line-inner"
                :style="passwordCountDownStyle"
              ></div>
            </div>
            <button
              @click="userLogin"
              :disabled="password.length <= 0 || isBusy"
            >
              <Spinner
                v-if="isBusy"
                :width="'3px'"
                :size="'24px'"
                :color="'#fff'"
              /><span>Sign In</span>
            </button>
            <div class="error-message">
              <div class="message-body" v-if="wrongPassword">
                Wrong password
              </div>
            </div>

            <div class="forgot-password">
              <div @click="sendForgotPassword">Forgot password?</div>
            </div>
          </div>
          <div class="account-input" v-else-if="sendForgotPasswordStatus != -1">
            <div
              class="forgot-password-page"
              v-if="sendForgotPasswordStatus == 0"
            >
              <Spinner :width="'3px'" :size="'48px'" :color="'#888'" />
              <div>Sending reset password email...</div>
            </div>
            <div
              v-else-if="sendForgotPasswordStatus == 1"
              class="forgot-password-page"
            >
              <IconCheckCircle class="icon green" />
              <div>Reset password e-mail sent. Please check your inbox.</div>
              <button @click="reset">Back to login</button>
            </div>
            <div
              v-else-if="sendForgotPasswordStatus == 2"
              class="forgot-password-page"
            >
              <IconCloseCircle class="icon red" />
              Failed to send reset password e-mail. Please try again later.
              <button @click="sendForgotPassword">retry</button>
              <button @click="reset">Back to login</button>
            </div>
          </div>
          <div
            class="verification-code-input"
            v-else-if="inputVerificationCode"
          >
            <div class="heading">Verification Code</div>
            <VerificationCode
              ref="verificationCodeInput"
              v-model="verificationCode"
              @input="verificationCodeInputHandler"
              @keyPressed="verificationCodeNotMatch = false"
            />
            <div class="code-not-match" v-if="verificationCodeNotMatch">
              Code Not Match
            </div>
          </div>
        </div>
      </div>
      <img class="tv-logo" src="@/assets/tv.svg" v-if="app.whiteLabel == 0" />
    </div>
    <div class="copyright" v-if="app.whiteLabel == 0">
      © 2009 - {{ getYear() }} Top Vista Digital Media Solutions Ltd, all rights
      reserved.
    </div>
    <div class="copyright" v-else-if="app.whiteLabel == 1">
      Powered By TOPVISTA / EYECON
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import IconArrowLeft from "@/components/Icons/IconArrowLeft";
import IconError from "@/components/Icons/IconError.vue";
import BackgroundImage from "@/components/BackgroundImage.vue";
import GoogleSignInCompleted from "@/components/GoogleSignInCompleted.vue";
import GoogleSignInMapping from "@/components/GoogleSignInMapping.vue";
import Spinner from "@/components/Spinner.vue";
import { settings, loadAppSettings } from "@/eyecon.js";
import IconCheckCircle from "@/components/Icons/IconCheckCircle.vue";
import IconCloseCircle from "@/components/Icons/IconCloseCircle.vue";
import VerificationCode from "@/components/VerificationCode.vue";
export default {
  name: "Login",
  components: {
    IconArrowLeft,
    IconError,
    IconCheckCircle,
    IconCloseCircle,
    BackgroundImage,
    GoogleSignInCompleted,
    GoogleSignInMapping,
    Spinner,
    VerificationCode,
  },
  data() {
    return {
      subDomain: "",
      returnPath: "",
      hasDomainParam: false,
      account: "",
      password: "",
      userName: "",
      userToken: "",
      accountExist: false,
      wrongPassword: false,
      showTenantsList: false,
      timer: null,
      passwordTimer: null,
      passwordTimeoutCounter: 0,
      googleInitTimer: null,
      slogansIndex: 0,
      googleSignInSuccess: false,
      googleUserInfo: null,
      googleUserMapped: false,
      googleIdToken: null,
      isBusy: false,
      errorMessage: null,
      loginKey: null,
      tenantId: null,
      loginSuccessMessage: "Sign In Successful",
      sendForgotPasswordStatus: -1,
      verificationCodeNotMatch: false,
      inputVerificationCode: false,
      verificationCode: "",
    };
  },
  computed: {
    ...mapGetters([
      "cloudLogin",
      "slogans",
      "domainName",
      "usingSSL",
      "enable2fa",
      "app",
    ]),
    logoPath() {
      return `${settings?.serverUrl}/repository/system/${this.app.logoPath}`;
    },
    protocol() {
      return this.usingSSL ? "https" : "http";
    },
    allowSignIn() {
      return this.account.length > 0 && this.subDomain.length > 0;
    },
    allowGoogleSignIn() {
      return this.subDomain.length > 0;
    },
    slogan() {
      return this.slogans[this.slogansIndex];
    },
    passwordCountDownStyle() {
      return {
        width: `${((120 - this.passwordTimeoutCounter) / 120) * 100}%`,
      };
    },
    forgotPasswordUrl() {
      if (this.domainName && this.subDomain && this.userToken) {
        return `${this.protocol}://${this.subDomain}.${this.domainName}/ResetPassword?token=${this.userToken}`;
      } else {
        return "";
      }
    },
  },

  methods: {
    ...mapActions([
      "__checkAccountExist",
      "__login",
      "__loginWithGoogleAccount",
      "__getServerSettings",
      "__forgotPassword",
      "__verifyTOTP",
    ]),
    reset() {
      this.googleSignInSuccess = false;
      this.googleUserInfo = null;
      this.googleUserMapped = false;
      this.googleIdToken = null;
      this.accountExist = false;
      this.password = "";
      this.account = "";
      this.userName = "";
      this.userToken = "";
      if (this.passwordTimer) {
        clearInterval(this.passwordTimer);
      }
      this.passwordTimeoutCounter = 0;
      (this.loginSuccessMessage = "Sign In Successful"),
        this.$nextTick(() => {
          this.initializeGoogleSignIn();
        });
      this.sendForgotPasswordStatus = -1;
      this.inputVerificationCode = false;
      this.verificationCode = "";
      this.verificationCodeNotMatch = false;
    },
    initializeGoogleSignIn() {
      this.isBusy = true;
      if (window.google && window.google.accounts) {
        this.renderGoogleButton();
      } else {
        // Wait for Google script to load
        this.googleInitTimer = setTimeout(() => {
          this.initializeGoogleSignIn();
        }, 100);
      }
      this.isBusy = false;
    },
    renderGoogleButton() {
      if (!settings.googleClientId || !settings.googleClientId.length > 0) {
        console.error("Google Client ID is not set in appsettings");
        return;
      }
      if (
        window.google &&
        window.google.accounts &&
        this.$refs.googleSignInButton &&
        settings.googleClientId &&
        settings.googleClientId.length > 0
      ) {
        window.google.accounts.id.initialize({
          client_id: settings.googleClientId,
          callback: this.handleCredentialResponse,
        });
        window.google.accounts.id.renderButton(this.$refs.googleSignInButton, {
          theme: "outline",
          size: "large",
          shape: "rectangular",
          logo_alignment: "center",
          width: 400,
        });
      }
    },
    async handleCredentialResponse(response) {
      this.isBusy = true;
      this.googleIdToken = response.credential;
      await this.sendGoogleTokenToBackend(response.credential);
      this.isBusy = false;
    },
    async sendGoogleTokenToBackend(token) {
      this.errorMessage = null;
      this.googleSignInSuccess = false;
      this.googleUserMapped = false;
      this.googleUserInfo = null;
      const payload = {
        idToken: token, // JWT token for backend verification
        domain: this.subDomain, // Your workspace domain
      };
      const login = await this.__loginWithGoogleAccount(payload);
      if (login) {
        const res = this.cloudLogin;
        this.googleUserInfo = res.googleUserInfo;
        this.googleSignInSuccess = true;
        this.googleUserMapped = res.loginKey ? true : false;
        this.loginKey = res.loginKey;
        this.tenantId = res.tenantId;
        if (this.enable2fa && this.cloudLogin.twoFactorSecret) {
          this.account = res.userId;
          this.verificationCodeNotMatch = false;
          this.inputVerificationCode = true;
        } else {
          setTimeout(() => {
            this.redirect();
          }, 2500);
        }
      } else {
        if (login?.message) {
          this.errorMessage = login.message;
        } else {
          this.errorMessage = "Google sign-in failed";
        }
      }
    },
    accountLinked(res) {
      this.loginSuccessMessage = "Account Linked Successful";
      this.googleUserMapped = true;
      this.loginKey = res.loginKey;
      this.tenantId = res.tenantId;
      this.redirect();
    },
    redirect() {
      if (this.cloudLogin.loginKey) {
        var url = `${this.protocol}://${this.subDomain}.${this.domainName}`;
        if (process.env.NODE_ENV === "development") {
          url = "http://localhost:8081";
        }
        url += `/CloudLoginRedirect?key=${this.cloudLogin.loginKey}`;
        var redirectPage = this.$route.query.redirectpage;
        if (redirectPage && redirectPage.length > 0) {
          url += `&redirectpage=${redirectPage}`;
        }
        window.location.href = url;
      }
    },
    passwordTimeout() {
      this.passwordTimeoutCounter++;
      if (this.passwordTimeoutCounter >= 120) {
        this.reset();
      }
    },
    async checkAccountExist() {
      this.isBusy = true;
      const payload = {
        id: this.account,
        domain: this.subDomain,
      };
      const ret = await this.__checkAccountExist(payload);
      if (ret?.success) {
        this.accountExist = true;
        this.userName = ret?.userName || this.account;
        this.userToken = ret?.userToken;
      } else {
        this.accountExist = false;
        this.userName = "";
        this.userToken = "";
        this.errorMessage =
          ret?.message || "System error, please try again later";
      }
      if (this.accountExist) {
        // remove google sign-in button
        const el = this.$refs.googleSignInButton;
        if (el) {
          el.innerHTML = "";
        }
        this.passwordTimeoutCounter = 0;
        this.passwordTimer = setInterval(this.passwordTimeout, 1000);
        this.$nextTick(() => {
          this.$refs.password.focus();
        });
      }
      this.isBusy = false;
    },
    base64Encode(str) {
      var bytesArray = [];

      for (var i = 0; i < str.length; ++i) {
        bytesArray.push(str.charCodeAt(i));
        bytesArray.push(0);
      }
      var binary = "";
      var bytes = new Uint8Array(bytesArray);
      var len = bytes.byteLength;
      for (i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    async userLogin() {
      this.sendForgotPasswordStatus = -1;
      this.isBusy = true;
      var password = this.password;
      var payload = {
        Username: this.account,
        Password: password,
        domain: this.subDomain,
      };
      var login = await this.__login(payload);
      if (login) {
        if (this.enable2fa && this.cloudLogin.twoFactorSecret) {
          this.verificationCodeNotMatch = false;
          this.inputVerificationCode = true;
        } else {
          this.redirect();
        }
      } else {
        this.wrongPassword = true;
      }
      if (this.wrongPassword) {
        this.$refs.password.focus();
        this.password = "";
      }
      this.isBusy = false;
    },
    backButtonClick() {
      this.reset();
      this.$nextTick(() => {
        this.renderGoogleButton();
        this.$refs.account.focus();
      });
    },
    getYear() {
      const d = new Date();
      return d.getFullYear();
    },
    async sendForgotPassword() {
      this.sendForgotPasswordStatus = 0;
      this.passwordTimeoutCounter = 0;

      this.sendForgotPasswordStatus = await this.__forgotPassword({
        domain: this.subDomain,
        id: this.account,
      });
    },

    async verificationCodeInputHandler(code) {
      if (code == null) return;
      this.verificationCodeNotMatch = false;
      if (code.length === 6) {
        if (await this.verifyTOTP()) {
          this.redirect();
        } else {
          this.shakeVerificationInput();
          this.$refs.verificationCodeInput.clear();
          this.verificationCodeNotMatch = true;
        }
      }
    },
    async verifyTOTP() {
      var success = await this.__verifyTOTP({
        id: this.account,
        value: this.verificationCode,
      });
      return success;
    },
    shakeVerificationInput() {
      const el = this.$refs.verificationCodeInput;
      if (el == null) return;
      el.shake();
    },
  },

  async mounted() {
    if (!settings || !settings.serverUrl) {
      await loadAppSettings();
    }
    await this.__getServerSettings();
    this.initializeGoogleSignIn();
    this.timer = setInterval(() => {
      this.slogansIndex = (this.slogansIndex + 1) % this.slogans.length;
    }, 8000);

    // read from query params to get the sub-domain
    const urlParams = new URLSearchParams(window.location.search);
    const subDomainParam = urlParams.get("domain");
    const returnPath = urlParams.get("return");
    if (subDomainParam) {
      this.subDomain = subDomainParam;
      this.hasDomainParam = true;
    }
    if (returnPath) {
      this.returnPath = returnPath;
    }

    this.$nextTick(() => {
      if (this.subDomain) {
        if (this.$refs.account) {
          this.$refs.account.focus();
        }
      } else {
        if (this.$refs.subDomain) {
          this.$refs.subDomain.focus();
        }
      }
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.passwordTimer) {
      clearInterval(this.passwordTimer);
    }
    if (this.googleInitTimer) {
      clearTimeout(this.googleInitTimer);
    }
  },
  watch: {
    subDomain(newValue) {
      // Update the URL with the new sub-domain
      if (newValue == null || newValue.length <= 0) {
        this.account = "";
      }
    },
    account(newValue, oldValue) {
      if (newValue != oldValue) {
        this.errorMessage = null;
        this.userName = "";
        this.userToken = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/themeColor.scss";
@font-face {
  font-family: "Montserrat";
  src: url("../assets/Montserrat-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Merriweather";
  src: url("../assets/Merriweather_96pt-Bold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roboto";
  src: url("../assets/Roboto-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roboto";
  src: url("../assets/Roboto-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Roboto";
  src: url("../assets/Roboto-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

.login {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-content: center;
  align-items: center;

  .copyright {
    font-size: 12px;
    opacity: 0.5;
    position: absolute;
    left: 0px;
    bottom: 0px;
    margin: 10px;
    pointer-events: none;
    user-select: none;
    color: #fff;
    filter: drop-shadow(0px 0px 1px #000);
  }

  .background {
    position: absolute;
    user-select: none;
    pointer-events: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: grid;
    justify-items: center;
    align-items: center;

    .hero-text {
      width: calc(100% - 600px);
      text-align: start;
      color: #fff;

      position: absolute;
      top: calc(50%);
      transform: translateY(-50%);
      left: 50px;
      font-family: "Montserrat", "Roboto", "-apple-system", "Helvetica Neue",
        Helvetica, Arial, sans-serif;

      div {
        display: block;
      }
      .title {
        font-family: "Merriweather", "Roboto", "-apple-system", "Helvetica Neue",
          Helvetica, Arial, sans-serif;
        font-weight: 600;
        font-size: 3em;
        filter: drop-shadow(0px 0px 2px #666);
      }
      .description {
        font-weight: 500;
        font-size: 1.4em;
        margin-top: 10px;
        padding-right: 50px;
        color: #eee;
        animation: descriptionFadeIn 0.5s ease-in-out 1s forwards;
        filter: drop-shadow(0px 0px 2px #666);
        opacity: 0;
      }
    }
  }
  .side-bar {
    position: absolute;

    width: 550px;
    min-width: 400px;
    right: 0px;
    top: 0px;
    height: 100%;
    background-color: #ffffff;
    user-select: none;
    .tv-logo {
      pointer-events: none;

      position: absolute;
      right: 0px;
      bottom: 0px;
      height: 12px;
      margin: 15px;
      filter: grayscale(100%);
    }
  }
  .content-outer {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-items: center;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .logo-section {
    margin-top: 60px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    user-select: none;
    pointer-events: none;
    .logo {
      position: relative;
      width: 64px;
      height: 64px;

      .eyecon-logo {
        width: 64px;
        height: 64px;
        justify-self: center;
        align-self: center;
        animation: updown 3s ease-in-out infinite;
      }
      .white-label-logo {
        width: 64px;
        height: 64px;
        justify-self: center;
        align-self: center;
      }
      .drop-shadow {
        position: absolute;
        bottom: -8px;
        left: 3px;
        right: 3px;
        height: 2px;
        border-radius: 50%;
        background: #333 !important;
        transform-origin: bottom center;
        filter: blur(4px);
        animation: scale-width 3s ease-in-out infinite;
      }
    }

    .title-section {
      font-family: "Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial,
        sans-serif;
      position: relative;
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      color: #555;
      gap: 5px;
      .eyecon {
        text-align: start;
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 0px;
      }
      .app-name {
        text-align: start;
        font-size: 17px;
        text-transform: uppercase;
        letter-spacing: 1.5px;
      }
    }
  }
  .content {
    position: relative;
    width: 550px;
    right: 0px;
    top: 0px;
    height: 100%;
    flex-flow: column;
    box-sizing: border-box;
    padding: 10px 75px;
    font-size: 15px;

    .account-input {
      width: 100%;
      display: grid;
      justify-items: start;
      color: #999;
      user-select: none;
      .password-topic {
        display: flex;
        align-items: center;
        column-gap: 10px;
        margin-bottom: 20px;
        font-size: 22px;
        color: $theme-color;
        .back-button {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: grid;
          align-items: center;
          justify-items: center;
          cursor: pointer;
          svg {
            fill: $theme-color;
            width: 32px;
            height: 32px;
          }
          &:hover {
            background-color: $theme-color-alpha-20;
          }
        }
      }

      .topic {
        margin-bottom: 20px;
        font-size: 22px;
        justify-self: self-start;
        align-items: center;
        color: $theme-color;
        display: flex;
        column-gap: 5px;
        span {
          pointer-events: none;
        }
        .back-button {
          width: 30px;
          height: 30px;
          border-radius: 15px;
          display: grid;
          align-items: center;
          justify-items: center;
          cursor: pointer;
          svg {
            fill: $theme-color;
            width: 20px;
            height: 20px;
          }
          &:hover {
            background-color: $theme-color-alpha-20;
          }
        }
      }

      .label {
        font-size: 14px;
        pointer-events: none;
      }

      .workspace-input {
        display: grid;
        grid-template-columns: 1fr auto;
        column-gap: 5px;
        width: 100%;
        margin-bottom: 25px;
        .domain-name {
          color: $theme-color;
          font-size: 18px;
          align-self: center;
        }
      }
      .workspace {
        box-sizing: border-box;
        width: 100%;
        height: 42px;
        display: grid;
        align-items: center;
        justify-items: center;
        font-size: 18px;
        color: $theme-color;
        border: 1px solid #999;
        border-radius: 4px;
        padding: 0px 10px;
        margin-bottom: 25px;
        margin-top: 10px;
        user-select: text;
      }
      .error-message {
        box-sizing: border-box;
        height: 60px;
        width: 100%;
        padding: 0px 30px;
        display: grid;
        justify-items: center;
        align-items: center;
        .message-body {
          width: 100%;
          padding: 10px 30px;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          gap: 10px;
          align-items: center;
          //background-color: #af1b1b;
          color: #af1b1b;
          svg {
            width: 20px;
            height: 20px;
            fill: #af1b1b;
          }
        }
      }
      .create-account {
        display: grid;
        margin-top: 5px;
        justify-self: center;
        .sign-up {
          margin-top: 20px;
          text-decoration: none;
        }
        .disable-sign-up {
          opacity: 0.1;
          pointer-events: none;
        }
      }
      .forgot-password {
        margin-top: 10px;
        cursor: pointer;
        border-bottom: #999 1px solid;
        justify-self: end;
        &:hover {
          color: $theme-color;
          border-bottom: $theme-color 1px solid;
        }
      }
      .forgot-password-page {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-items: center;
        row-gap: 24px;
        font-size: 16px;
        margin-top: 20px;
        width: 100%;
        .icon {
          width: 48px;
          height: 48px;
        }
        .green {
          fill: #4caf50;
        }
        .red {
          fill: #ff7268;
        }
      }
      input {
        justify-self: stretch;
        font-size: 15px;
        min-height: 40px;
        padding: 0px 10px;
        margin-top: 10px;
        border: 1px solid #999;
        border-radius: 4px;
        background-color: #fefefe;
      }
      input:focus {
        outline: 1px solid $theme-color-alpha-70;
        border: 1px solid $theme-color;
      }
      button:disabled {
        background-color: #ccc;
      }
      button {
        font-size: 14px;
        width: 100%;
        min-height: 42px;
        margin-top: 20px;
        padding: 0px 10px;
        border: 0px;
        border-radius: 4px;
        background-color: $theme-color;
        color: #ffffff;
        cursor: pointer;
        text-transform: uppercase;
        letter-spacing: 1px;
        word-spacing: 3px;
        display: flex;
        gap: 5px;
        align-items: center;
        justify-content: center;
      }
      button:disabled {
        pointer-events: none;
        opacity: 0.5;
      }
      button:focus {
        outline: 2px solid $theme-color-alpha-70;
      }
      .google-sign-in-outer {
        display: grid;
        gap: 0px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .disable-google-sign-in {
        pointer-events: none;
        opacity: 0.5;
      }
      .google-sign-in-button {
        margin-top: 20px;
        width: 400px;
        display: flex;
        justify-content: center;
      }
    }
    .verification-code-input {
      position: relative;
      padding: 30px 60px;
      min-height: 280px;
      color: #333;
      font-size: 14px;
      display: block;
      .heading {
        text-align: center;
        font-size: 16px;
      }
      .code-not-match {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2px;
        margin-top: 30px;
        color: #f44336;
        font-size: 14px;
        svg {
          fill: #f44336;
          width: 20px;
          height: 20px;
        }
      }
    }
    .site-select {
      display: grid;
      border: 1px solid #ddd;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 4px;
      .topic {
        justify-self: start;
        text-align: start;
        margin-bottom: 30px;
      }
      .site {
        position: relative;
        width: 100%;
        height: 300px;
        border: 0px;
        overflow-y: auto;
        overflow-x: hidden;
        .site-inner {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          .item {
            min-height: 50px;
            background-color: #eeeeee;
            border-radius: 4px;
            margin-bottom: 5px;
            display: grid;
            align-items: center;
            grid-template-columns: 40px 1fr 40px;
            column-gap: 5px;
            .icon {
              fill: #777;
              width: 26px;
              height: 26px;
              justify-self: center;
            }
            .name {
              justify-self: start;
              color: #777;
            }
            &:hover {
              background-color: $theme-color-alpha-70;
              .pointer {
                display: block;
                cursor: pointer;
              }
              .name {
                color: #fff;
              }
              .icon {
                fill: #fff;
              }
            }

            .pointer {
              fill: #ffffff80;
              width: 26px;
              height: 26px;
              justify-self: center;
              display: none;
              pointer-events: none;
            }
          }
          .selected {
            background-color: $theme-color;
            .icon {
              fill: #fff !important;
            }
            .name {
              color: #fff !important;
            }
            &:hover {
              background-color: $theme-color;
            }
            .pointer {
              fill: #fff !important;
              display: block !important;
              pointer-events: all;
            }
          }
        }
      }
    }
  }
}

.countdown-line {
  margin-top: 20px;
  opacity: 0.3;
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #ccc;
  .countdown-line-inner {
    width: 0%;
    height: 100%;
    background-color: $theme-color;
  }
}

@keyframes updown {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-3px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes scale-width {
  0% {
    transform: scaleX(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scaleX(1);
    opacity: 0.6;
  }
  100% {
    transform: scaleX(0.9);
    opacity: 0.8;
  }
}

@keyframes descriptionFadeIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Slogan fade transition */
.slogan-fade-enter-active,
.slogan-fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.slogan-fade-enter {
  opacity: 0;
  transform: translateY(20px);
}

.slogan-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
